import { FC } from 'react';
import { TreatmentGroup } from '@/model/TreatmentGroup.model.ts';
import styles from './GroupListItem.module.scss';

interface GroupListItemProps {
  group: TreatmentGroup;
  showControlChip?: boolean;
}

export const GroupListItem: FC<GroupListItemProps> = ({ group, showControlChip = true }) => {
  return (
    <div
      className={`flex flex-row justify-start items-center mb2`}
      data-test-component="GroupListItem"
      data-test-element="container"
      data-testid="group-list-item"
      data-test-key={group.api_id ?? group.temp_id}
      data-test-group-id={group.api_id ?? group.temp_id}
    >
      {showControlChip && (
        <>
          {group.control === true ? (
            <span className={styles.controlChip} style={{ minWidth: '20px' }} data-testid="control-chip">
              C
            </span>
          ) : (
            <span style={{ minWidth: '20px' }} data-testid="control-chip-placeholder"></span>
          )}
        </>
      )}
      <span className="ml2">
        <span
          className="mr1 dib br1"
          style={{ backgroundColor: group.color, width: 11, height: 11 }}
          data-testid="group-color-indicator"
        />
      </span>
      <span className="ml2" data-testid="group-name">
        {group.name}
      </span>
    </div>
  );
};
